import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPatientProcedures } from 'app/entities/patient-procedure/patient-procedure.reducer';
import { getEntities as getProcedurePrices } from 'app/entities/procedure-price/procedure-price.reducer';
import { getEntities as getHospitalPatientCategoryAttributes } from 'app/entities/hospital-patient-category-attributes/hospital-patient-category-attributes.reducer';
import { createEntity, getEntity, reset, updateEntity } from './patient-procedure-charge.reducer';

export const PatientProcedureChargeUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const patientProcedures = useAppSelector(state => state.patientProcedure.entities);
  const procedurePrices = useAppSelector(state => state.procedurePrice.entities);
  const hospitalPatientCategoryAttributes = useAppSelector(state => state.hospitalPatientCategoryAttributes.entities);
  const patientProcedureChargeEntity = useAppSelector(state => state.patientProcedureCharge.entity);
  const loading = useAppSelector(state => state.patientProcedureCharge.loading);
  const updating = useAppSelector(state => state.patientProcedureCharge.updating);
  const updateSuccess = useAppSelector(state => state.patientProcedureCharge.updateSuccess);

  const handleClose = () => {
    navigate(`/patient-procedure-charge${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPatientProcedures({}));
    dispatch(getProcedurePrices({}));
    dispatch(getHospitalPatientCategoryAttributes({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.performedDate !== undefined && typeof values.performedDate !== 'number') {
      values.performedDate = Number(values.performedDate);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }
    if (values.fromDate !== undefined && typeof values.fromDate !== 'number') {
      values.fromDate = Number(values.fromDate);
    }
    if (values.toDate !== undefined && typeof values.toDate !== 'number') {
      values.toDate = Number(values.toDate);
    }
    if (values.discount !== undefined && typeof values.discount !== 'number') {
      values.discount = Number(values.discount);
    }

    const entity = {
      ...patientProcedureChargeEntity,
      ...values,
      procedure: patientProcedures.find(it => it.id.toString() === values.procedure?.toString()),
      appliedCharge: procedurePrices.find(it => it.id.toString() === values.appliedCharge?.toString()),
      multiplierEntry: hospitalPatientCategoryAttributes.find(it => it.id.toString() === values.multiplierEntry?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...patientProcedureChargeEntity,
          procedure: patientProcedureChargeEntity?.procedure?.id,
          appliedCharge: patientProcedureChargeEntity?.appliedCharge?.id,
          multiplierEntry: patientProcedureChargeEntity?.multiplierEntry?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.patientProcedureCharge.home.createOrEditLabel" data-cy="PatientProcedureChargeCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.patientProcedureCharge.home.createOrEditLabel">
              Create or edit a PatientProcedureCharge
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="patient-procedure-charge-id"
                  label={translate('tinyMedicRestApp.patientProcedureCharge.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedureCharge.performedDate')}
                id="patient-procedure-charge-performedDate"
                name="performedDate"
                data-cy="performedDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedureCharge.active')}
                id="patient-procedure-charge-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedureCharge.cursor')}
                id="patient-procedure-charge-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedureCharge.lastUpdated')}
                id="patient-procedure-charge-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedureCharge.microSec')}
                id="patient-procedure-charge-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedureCharge.timestampEntry')}
                id="patient-procedure-charge-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedureCharge.fromDate')}
                id="patient-procedure-charge-fromDate"
                name="fromDate"
                data-cy="fromDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedureCharge.toDate')}
                id="patient-procedure-charge-toDate"
                name="toDate"
                data-cy="toDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedureCharge.discount')}
                id="patient-procedure-charge-discount"
                name="discount"
                data-cy="discount"
                type="text"
              />
              <ValidatedField
                id="patient-procedure-charge-procedure"
                name="procedure"
                data-cy="procedure"
                label={translate('tinyMedicRestApp.patientProcedureCharge.procedure')}
                type="select"
              >
                <option value="" key="0" />
                {patientProcedures
                  ? patientProcedures.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="patient-procedure-charge-appliedCharge"
                name="appliedCharge"
                data-cy="appliedCharge"
                label={translate('tinyMedicRestApp.patientProcedureCharge.appliedCharge')}
                type="select"
              >
                <option value="" key="0" />
                {procedurePrices
                  ? procedurePrices.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="patient-procedure-charge-multiplierEntry"
                name="multiplierEntry"
                data-cy="multiplierEntry"
                label={translate('tinyMedicRestApp.patientProcedureCharge.multiplierEntry')}
                type="select"
              >
                <option value="" key="0" />
                {hospitalPatientCategoryAttributes
                  ? hospitalPatientCategoryAttributes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/patient-procedure-charge" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PatientProcedureChargeUpdate;
